import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { FirstCutProps } from "./FirstCut";
const FirstCut = lazy(() => import("./FirstCut").then(module => ({ default: module.FirstCut })));
export function mountFirstCut(slot: HTMLElement, projectId: string, props: FirstCutProps) {
  setStudioView("stage", `first-cut:${projectId}`, <FirstCut {...props} />);
}
